module.exports = __webpack_public_path__ + "assets/img/title-67371fd2.png";